module.exports = __webpack_public_path__ + "assets/img/title-8a228195.png";